import React, { useMemo } from "react";
import Sections from "./sections";

const RowLayout = ({ rows, ...rest }) => {
  const onItemUserAction = () => {};

  return (
    <div className="config-card-section">
      <div className="config-card-section-content">
        {rows &&
          rows.map((row) => {
            return (
              <Sections
                layout={row?.layout}
                items={row?.items}
                value={row?.value || {}}
                onItemUserAction={onItemUserAction}
              />
            );
          })}
      </div>

      <style jsx>{`
        .config-card-section {
          &-content {
            display: flex;
            flex-flow: column nowrap;
            gap: 1rem;
          }
        }
      `}</style>
    </div>
  );
};

export default RowLayout;
